import React from "react";
import { withTranslation } from "react-i18next";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";

import { api } from "@/utils/api";
import FaqListItem from "@/react-components/FaqListItem";

class FAQ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      faqInfos: undefined,
    };
  }
  componentDidMount() {
    this.fetchData();
  }
  fetchData = () => {
    api.faq
      .getList()
      .then((res) => {
        this.setState({
          faqInfos: res,
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };
  render() {
    const { faqInfos } = this.state;
    const { routeData } = this.props;
    return (
      <div className="faq">
        <div className="faq-inner">
          <h2>よくある質問・お問い合わせ</h2>
          {/* <p>
            このページではTrynibus全般に関するよくあるご質問にお答えしています。各回答をご覧ください。
          </p> */}
          <h3>■ よくある質問</h3>
          <div className="faq-conetnts">
            {faqInfos && faqInfos.length > 0
              ? faqInfos.map((item, index) => (
                  <FaqListItem key={index} data={item} />
                ))
              : ""}
          </div>
          <h3 className="margin-top-64">■ お問い合わせ</h3>
        </div>
        <Placeholder
          name="jss-contact"
          rendering={routeData}
          routeData={routeData}
        />
      </div>
    );
  }
}

export default withTranslation()(FAQ);
